/**
 * Navbar.jsx
 * Executive sidebar: nameplate, navigation, search, and professional links.
 */

import {useRef, useCallback} from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faHouse, faCode, faMugHot, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { faLinkedinIn, faGithub } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

import {useNavHelper} from '#hooks/useNavHelper';
import config from '#config/server';

export function Navbar(){
	const navigate = useNavHelper();
	const inputRef = useRef();
	const setInputRef = useCallback(node=>{ if(node) inputRef.current = node; });

	const navClass = ({isActive}) => "nav-link" + (isActive ? " active" : "");

	return (<nav className="navbar navbar-expand-lg" id="sideNav">
		{/* Mobile brand */}
		<a className="brand-badge d-lg-none" href="#" onClick={e=>navigate(e, '/')}>
			<span className="brand-dot" /> Robert Parham
		</a>
		<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
			<span className="navbar-toggler-icon" />
		</button>

		{/* Desktop nameplate */}
		<a href="#" onClick={e=>navigate(e, '/')} className="sidebar-avatar-wrap" style={{textAlign:'center'}}>
			<img src={`${config.base_url}assets/images/rob-avatar.jpg`} alt="Robert Parham" />
		</a>
		<div className="d-none d-lg-block" style={{width:'100%'}}>
			<p className="nav-title">Robert Parham</p>
			<p className="nav-eyebrow">TECHNOLOGY LEADER</p>
		</div>

		<div className="collapse navbar-collapse" id="navbarResponsive">
			<form className="side-search my-3 w-100" role="search" onSubmit={e=>navigate(e, '/search/'+encodeURIComponent(inputRef.current.value.trim()))}>
				<div className="input-group">
					<input type="search" className="form-control" placeholder="Search" ref={setInputRef} />
					<button className="btn" type="submit" aria-label="Search">
						<FontAwesomeIcon icon={faMagnifyingGlass} />
					</button>
				</div>
			</form>

			<ul className="navbar-nav">
				<li className="nav-item">
					<NavLink to="/" end className={navClass}><FontAwesomeIcon className="nav-ic" icon={faHouse} /> Home</NavLink>
				</li>
				<li className="nav-item">
					<NavLink to="/resume" className={navClass}><FontAwesomeIcon className="nav-ic" icon={faFilePdf} /> Résumé</NavLink>
				</li>
				<li className="nav-item">
					<NavLink to="/code" className={navClass}><FontAwesomeIcon className="nav-ic" icon={faCode} /> Engineering</NavLink>
				</li>
			</ul>

			<div className="side-foot">
				<div className="side-socials">
					<a href="https://www.linkedin.com/in/robert-parham/" target="_blank" rel="noopener" title="LinkedIn"><FontAwesomeIcon icon={faLinkedinIn} /></a>
					<a href="https://github.com/Pamblam" target="_blank" rel="noopener" title="GitHub"><FontAwesomeIcon icon={faGithub} /></a>
					<a href="mailto:adelphia@proton.me" title="Email"><FontAwesomeIcon icon={faEnvelope} /></a>
				</div>
			</div>
		</div>
	</nav>);
}
